import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40c2e08c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-collapse" }
const _hoisted_2 = { class: "square-item flex flex-col sm:flex-row relative" }
const _hoisted_3 = { class: "basis-1/2 flex flex-col sm:max-w-[50%] product-description px-[16px] sm:px-[40px] py-[12px] sm:py-[40px]" }
const _hoisted_4 = { class: "product-detail-header" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "description-title mb-1.5" }
const _hoisted_7 = { class: "description-tag" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "under_line" }, null, -1))
const _hoisted_9 = { class: "product-detail-qty flex flex-col gap-4" }
const _hoisted_10 = { class: "flex flex-column items-center" }
const _hoisted_11 = { class: "basis-[60px] tracking-widest" }
const _hoisted_12 = { class: "flex items-center flex-grow pl-8" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "option select flex items-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "數量", -1))
const _hoisted_17 = { class: "flex-grow pl-8" }
const _hoisted_18 = { class: "w-[90px]" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "under_line hidden sm:block" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "product-detail-body"
}
const _hoisted_21 = { class: "description-content sm:h-[370px] sm:mb-[10px] sm:overflow-y-scroll" }
const _hoisted_22 = {
  key: 0,
  class: "add-on"
}
const _hoisted_23 = { class: "flex basis-full items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ml-[9px] text-gary-text-color font-bold text-[0.937rem]" }, " 禮品包裝 ", -1))
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "g-collapse" }
const _hoisted_27 = { class: "flex flex-nowrap overflow-auto gap-[3px] pt-[4px]" }
const _hoisted_28 = { class: "text-sm mt-[6px] text-gary-text-color relative cursor-pointer" }
const _hoisted_29 = { class: "truncate" }
const _hoisted_30 = { class: "text-xs" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs line-through text-light-gary-text-color"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" + NT. ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "under_line" }, null, -1))
const _hoisted_34 = { class: "include-description" }
const _hoisted_35 = { class: "flex flex-col sm:flex-row basis-full" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-bold text-[0.937rem] sm:basis-[60px] w-[60px]" }, " 禮物包含 ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:basis-[43px]" }, null, -1))
const _hoisted_38 = { class: "flex-grow text-sm font-light" }
const _hoisted_39 = { class: "tracking-widest mb-1" }
const _hoisted_40 = {
  key: 0,
  class: "tracking-widest mb-1 flex justify-between"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden tracking-widest mb-1" }, "貼紙 x1", -1))
const _hoisted_42 = {
  key: 1,
  class: "mt-5 text-gary-text-color"
}
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = { class: "ml-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "under_line" }, null, -1))
const _hoisted_46 = { class: "flex flex-col" }
const _hoisted_47 = {
  key: 0,
  class: "px-[6px] flex items-center"
}
const _hoisted_48 = { class: "inline-block ml-[9px] text-gary-text-color font-light text-sm tracking-[.06em]" }
const _hoisted_49 = { class: "w-[24px]" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "under_line"
}
const _hoisted_52 = {
  key: 2,
  class: "mb-[30px]"
}
const _hoisted_53 = { class: "flex justify-between items-center mb-[12px] pr-[1px]" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color tracking-[.06em]" }, " 產品說明 ", -1))
const _hoisted_55 = {
  key: 1,
  class: "flex flex-col mb-3 tracking-[.06em]"
}
const _hoisted_56 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_57 = { class: "inline-flex" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "・", -1))
const _hoisted_59 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_60 = { class: "flex justify-between items-center pr-[1px]" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color tracking-[.06em]" }, " 注意事項 ", -1))
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_64 = { class: "inline-flex" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "・", -1))
const _hoisted_66 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_67 = {
  key: 3,
  class: "add-on mt-5 pt-5"
}
const _hoisted_68 = { class: "flex basis-full items-center" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ml-[9px] text-gary-text-color font-bold text-[0.937rem]" }, " 加購 ", -1))
const _hoisted_70 = { class: "w-full" }
const _hoisted_71 = { class: "g-collapse" }
const _hoisted_72 = { class: "flex flex-nowrap overflow-auto" }
const _hoisted_73 = { class: "text-base mt-[6px] text-gary-text-color relative cursor-pointer" }
const _hoisted_74 = { class: "text-sm" }
const _hoisted_75 = {
  key: 0,
  class: "text-xs line-through text-light-gary-text-color"
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" + NT. ")
const _hoisted_77 = { class: "flex justify-end gap-2" }
const _hoisted_78 = {
  key: 4,
  class: "hidden description-content__option flex flex-col sm:flex-row"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-content__option__title mb-[2px] sm:mb-0 basis-1/4" }, " 包裝(選購) ", -1))
const _hoisted_80 = { class: "description-content__option__content basis-3/4 flex flex-row" }
const _hoisted_81 = {
  key: 1,
  class: "product-detail-footer"
}
const _hoisted_82 = { class: "flex justify-between mt-[16px]" }
const _hoisted_83 = {
  key: 0,
  class: "flex flex-col grow mr-3 sm:mr-7"
}
const _hoisted_84 = { class: "w-[240px] sm:w-[300px] ml-[6px] mt-4 text-gary-text-color font-light text-sm" }
const _hoisted_85 = { class: "mt-2 flex justify-between" }
const _hoisted_86 = { class: "w-[240px] sm:w-[300px] ml-[6px] mt-4 text-gary-text-color font-light text-sm" }
const _hoisted_87 = {
  key: 1,
  class: "grow h-[50px] tracking-[.1em] rounded-lg mr-3 sm:mr-7 text-white bg-gary-text-color sm:h-[50px] cursor-default sm:rounded-[10px]"
}
const _hoisted_88 = { class: "flex flex-col w-[80px] sm:w-[100px]" }
const _hoisted_89 = {
  key: 0,
  class: "text-[13px] items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_90 = { class: "text-[20px] items-center text-primary-color text-right" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "under_line sm:hidden" }, null, -1))
const _hoisted_92 = {
  key: 2,
  class: "product-detail-more"
}
const _hoisted_93 = { class: "flex text-xs text-white sm:text-lg flex-row justify-end" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-[10px] sm:pl-[26px]" }, "View More", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2.5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_SwiperSquareItem = _resolveComponent("SwiperSquareItem")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_ImageRadioButton = _resolveComponent("ImageRadioButton")!
  const _component_TextRadioButton = _resolveComponent("TextRadioButton")!
  const _component_InputWithButton = _resolveComponent("InputWithButton")!
  const _component_Spacer = _resolveComponent("Spacer")!
  const _component_TransitionPlusButton = _resolveComponent("TransitionPlusButton")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_Collapse = _resolveComponent("Collapse")!
  const _component_Input = _resolveComponent("Input")!
  const _component_AddPortFolioModal = _resolveComponent("AddPortFolioModal")!
  const _component_AddOnModal = _resolveComponent("AddOnModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectItemDetail)
      ? (_openBlock(), _createBlock(_component_Collapse, { key: 0 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "close sm:hidden z-[2]",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeRecItem()))
                }, [
                  _createVNode(_component_Icon, {
                    iconName: "close_black",
                    width: "24px"
                  })
                ]),
                _createVNode(_component_SwiperSquareItem, {
                  selectItem: _ctx.selectItemDetail.CmdyImageList,
                  "onUpdate:selectItem": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectItemDetail.CmdyImageList) = $event)),
                  class: "w-full sm:w-1/2 z-[1]"
                }, null, 8, ["selectItem"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.unescapeHTML(_ctx.selectItemDetail.Name || '')), 1),
                      _createVNode(_component_FavoriteButton, {
                        class: "cursor-pointer",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addToCollect(_ctx.selectItemDetail))),
                        isLike: _ctx.selectItemDetail.IsInCmdyCollect,
                        width: '24px'
                      }, null, 8, ["isLike"])
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.selectItemDetail.SubName), 1)
                  ]),
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    (!_ctx.hideSpec)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.specList, (spec) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: spec.CmdySpecId,
                            class: "product__options text-[15px] sm:text-base text-gary-text-color font-normal"
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(spec.Name), 1),
                              _createElementVNode("div", _hoisted_12, [
                                (spec.ShowMode === 'Thumbnail')
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(spec.CmdySpecOptionList, (optionItem) => {
                                      return (_openBlock(), _createBlock(_component_ImageRadioButton, {
                                        key: optionItem.CmdySpecId,
                                        name: optionItem.CmdySpecId,
                                        inputValue: optionItem.CmdySpecOptionId,
                                        width: "40px",
                                        text: optionItem.Name,
                                        url: optionItem.Image.PcWeb,
                                        title: optionItem.Name,
                                        modelValue: _ctx.optionModel[spec.CmdySpecId],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.optionModel[spec.CmdySpecId]) = $event),
                                        onClick: _ctx.changeOption
                                      }, null, 8, ["name", "inputValue", "text", "url", "title", "modelValue", "onUpdate:modelValue", "onClick"]))
                                    }), 128))
                                  : (spec.ShowMode === 'Dropdown')
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 1,
                                        class: "border-[1px] w-fit",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.optionModel[spec.CmdySpecId]) = $event),
                                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeOption && _ctx.changeOption(...args)))
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spec.CmdySpecOptionList, (optionItem) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: optionItem.CmdySpecId,
                                            value: optionItem.CmdySpecOptionId
                                          }, _toDisplayString(optionItem.Name), 9, _hoisted_14))
                                        }), 128))
                                      ], 40, _hoisted_13)), [
                                        [_vModelSelect, _ctx.optionModel[spec.CmdySpecId]]
                                      ])
                                    : (spec.ShowMode === 'BoxLabel')
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(spec.CmdySpecOptionList, (optionItem) => {
                                          return (_openBlock(), _createBlock(_component_TextRadioButton, {
                                            key: optionItem.CmdySpecId,
                                            name: optionItem.CmdySpecId,
                                            inputValue: optionItem.CmdySpecOptionId,
                                            text: optionItem.Name,
                                            modelValue: _ctx.optionModel[spec.CmdySpecId],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.optionModel[spec.CmdySpecId]) = $event),
                                            onClick: _ctx.changeOption
                                          }, null, 8, ["name", "inputValue", "text", "modelValue", "onUpdate:modelValue", "onClick"]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    (
                _ctx.isGoProductDetailRef === false &&
                _ctx.selectItemDetail.IsEndProduct === 1
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_InputWithButton, {
                                maxNumber: _ctx.selectItemDetail.MaxCmdyQty,
                                onSubtractClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.subtractClick())),
                                onAddClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addClick())),
                                modelValue: _ctx.cmdyQty,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cmdyQty) = $event))
                              }, null, 8, ["maxNumber", "modelValue"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_19,
                  (_ctx.selectItemDetail.CmdyType === 'IPMain')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.selectedCmdyPackage?.length !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_Icon, { iconName: "package" }),
                                  _hoisted_24,
                                  _createVNode(_component_Spacer),
                                  _createVNode(_component_TransitionPlusButton, {
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.packageShow = !_ctx.packageShow)),
                                    actived: !_ctx.packageShow
                                  }, null, 8, ["actived"])
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_Collapse, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", _hoisted_26, [
                                        _createVNode(_component_Swiper, {
                                          autoplay: { delay: 3000 },
                                          loop: false,
                                          navigation: {
                          hiddenClass: 'swiper-button-hidden',
                          prevEl: 'g-swiper-nav-prev',
                          nextEl: 'g-swiper-nav-next'
                        }
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkArray(_ctx.selectedCmdyPackage, 3), (chunk, slideIndex) => {
                                              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: slideIndex }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_27, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (cmdy) => {
                                                      return (_openBlock(), _createBlock(_component_SquareItemFullImage, {
                                                        key: cmdy.CmdyId,
                                                        onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(cmdy, 'Package')),
                                                        class: _normalizeClass(["max-w-[33%] sm:max-w-[25%] p-[3px] border-[3px] hover:border-black-300-color rounded-lg", [
                                  cmdy.Checked ? 'border-primary-color' : 'border-light-gary-color'
                                ]]),
                                                        customClass: ''
                                                      }, {
                                                        description: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_28, [
                                                            _createElementVNode("div", _hoisted_29, _toDisplayString(cmdy.Name), 1),
                                                            _createElementVNode("div", _hoisted_30, "+ NT. " + _toDisplayString(cmdy.UnitFeeReal), 1),
                                                            (cmdy.UnitFeeReal !== cmdy.UnitFeeOri)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                  _hoisted_32,
                                                                  _createElementVNode("span", null, _toDisplayString(cmdy.UnitFeeOri), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            _createVNode(_component_Icon, {
                                                              onClick: _withModifiers(($event: any) => (_ctx.setPackage(cmdy)), ["stop"]),
                                                              iconName: cmdy.Checked ? 'add_on_select' : 'circle_add',
                                                              width: '20px',
                                                              class: "cursor-pointer absolute right-0 bottom-0"
                                                            }, null, 8, ["onClick", "iconName"])
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick", "class"]))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ], 512), [
                                        [_vShow, _ctx.packageShow]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _hoisted_33
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _hoisted_37,
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.selectItemDetail.Name) + " x" + _toDisplayString(_ctx.cmdyQty), 1),
                                (_ctx.getSelectedPackage?.length !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _createTextVNode(_toDisplayString(_ctx.getSelectedPackage[0].Name) + " x" + _toDisplayString(_ctx.cmdyQty) + " ", 1),
                                      _createElementVNode("span", null, " + NT. " + _toDisplayString(_ctx.getSelectedPackage[0].UnitFeeReal *
                          _ctx.getSelectedPackage[0].CmdyQty), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_41,
                                (_ctx.getSelectedAddOn.length !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSelectedAddOn, (AddOnCmdyItem) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: AddOnCmdyItem.CmdyId,
                                          class: "flex items-center justify-between"
                                        }, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createVNode(_component_Icon, {
                                              iconName: "plus",
                                              width: "16px"
                                            }),
                                            _createElementVNode("div", _hoisted_44, [
                                              _createElementVNode("div", null, " 加購 " + _toDisplayString(AddOnCmdyItem.Name) + " x" + _toDisplayString(AddOnCmdyItem.CmdyQty), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", null, " + NT. " + _toDisplayString(AddOnCmdyItem.UnitFeeReal * AddOnCmdyItem.CmdyQty), 1)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _hoisted_45
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            (_ctx.isGoProductDetailRef === false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createVNode(_component_Icon, { iconName: "cart" }),
                                  _createElementVNode("div", _hoisted_48, " 今天訂購 約 " + _toDisplayString(_ctx.selectItemDetail.MinPreparationDays) + "-" + _toDisplayString(_ctx.selectItemDetail.MaxPreparationDays) + "天 到貨，不含假日及國定假期 ", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectItemDetail.PromotionList, (promotionItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: promotionItem.PromotionActivityId,
                                class: "flex px-[6px] flex basis-full"
                              }, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_Icon, { iconName: "giveaway_big" })
                                ]),
                                _createElementVNode("div", {
                                  class: "ml-[9px] text-primary-color font-light text-sm tracking-widest cursor-pointer",
                                  onClick: (e) => {e.preventDefault(); e.stopPropagation(); _ctx.EventBus.emit('openActivityModal', promotionItem.PromotionActivityId); }
                                }, _toDisplayString(promotionItem.PromotionActivityName), 9, _hoisted_50)
                              ]))
                            }), 128)),
                            (_ctx.isGoProductDetailRef === false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51))
                              : _createCommentVNode("", true),
                            (_ctx.isGoProductDetailRef === true && _ctx.specList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createVNode(_component_TransitionPlusButton, {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.productDescShow = !_ctx.productDescShow)),
                              actived: !_ctx.productDescShow
                            }, null, 8, ["actived"])
                          ]),
                          (_ctx.productDescShow)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectItemDetail.SpecDesc)
                    .ProductDesc.DescList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "text-sm text-breadcrumb-color",
                                    key: index
                                  }, _toDisplayString(item.Spec), 1))
                                }), 128)),
                                _createElementVNode("ul", _hoisted_56, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(
                      _ctx.selectItemDetail.SpecDesc
                    ).ProductDesc?.SpecList, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _hoisted_58,
                                        _createElementVNode("span", _hoisted_59, _toDisplayString(item.Spec), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _createVNode(_component_TransitionPlusButton, {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.warningShow = !_ctx.warningShow)),
                              actived: !_ctx.warningShow
                            }, null, 8, ["actived"])
                          ]),
                          (_ctx.warningShow)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("ul", _hoisted_63, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(
                      _ctx.selectItemDetail.SpecDesc
                    ).WarningList?.SpecList, (item, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _hoisted_65,
                                        _createElementVNode("span", _hoisted_66, _toDisplayString(item.Warning), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedCmdyAddOn.length !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _createVNode(_component_Icon, { iconName: "add_on" }),
                                  _hoisted_69,
                                  _createVNode(_component_Spacer),
                                  _createVNode(_component_TransitionPlusButton, {
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addOnShow = !_ctx.addOnShow)),
                                    actived: !_ctx.addOnShow
                                  }, null, 8, ["actived"])
                                ]),
                                _createElementVNode("div", _hoisted_70, [
                                  _createVNode(_component_Collapse, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", _hoisted_71, [
                                        _createVNode(_component_Swiper, {
                                          autoplay: { delay: 3000 },
                                          loop: false,
                                          navigation: {
                          hiddenClass: 'swiper-button-hidden',
                          prevEl: 'g-swiper-nav-prev',
                          nextEl: 'g-swiper-nav-next'
                        }
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkArray(_ctx.selectedCmdyAddOn, 3), (chunk, slideIndex) => {
                                              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: slideIndex }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_72, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (cmdy) => {
                                                      return (_openBlock(), _createBlock(_component_SquareItemFullImage, {
                                                        key: cmdy.CmdyId,
                                                        onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(cmdy, 'AddOn')),
                                                        image: cmdy.Image.PcWeb,
                                                        class: "max-w-[43%] sm:max-w-[33%] px-4",
                                                        customClass: ''
                                                      }, {
                                                        description: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_73, [
                                                            _createElementVNode("div", null, _toDisplayString(cmdy.Name), 1),
                                                            _createElementVNode("div", _hoisted_74, "+ NT. " + _toDisplayString(cmdy.UnitFeeReal), 1),
                                                            (cmdy.UnitFeeReal !== cmdy.UnitFeeOri)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                                  _hoisted_76,
                                                                  _createElementVNode("span", null, _toDisplayString(cmdy.UnitFeeOri), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_77, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(['cursor-pointer', cmdy.Checked ? 'num-icon' : ''])
                                                              }, [
                                                                (cmdy.Checked)
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                      _createTextVNode(_toDisplayString(cmdy.CmdyQty), 1)
                                                                    ], 64))
                                                                  : (_openBlock(), _createBlock(_component_Icon, {
                                                                      key: 1,
                                                                      iconName: "circle_add"
                                                                    }))
                                                              ], 2),
                                                              (cmdy.Checked)
                                                                ? (_openBlock(), _createBlock(_component_Icon, {
                                                                    key: 0,
                                                                    iconName: "trash-regular",
                                                                    class: "cursor-pointer",
                                                                    width: "24px",
                                                                    onClick: _withModifiers(($event: any) => (_ctx.removeAddOn(cmdy.CmdyId)), ["stop"])
                                                                  }, null, 8, ["onClick"]))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick", "image"]))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ], 512), [
                                        [_vShow, _ctx.addOnShow]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("div", _hoisted_80, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    class: "basis-[25%] mr-3",
                                    title: '一般包裝'
                                  }),
                                  _createVNode(_component_SquareItemFullImage, {
                                    class: "basis-[25%] mr-3",
                                    title: '精緻包裝'
                                  }),
                                  _createVNode(_component_SquareItemFullImage, {
                                    class: "basis-[25%]",
                                    title: '節慶包裝'
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isGoProductDetailRef === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          (_ctx.selectItemDetail.Status === 'OutOfStock')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                _createElementVNode("button", {
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sentRestockNotification(_ctx.selectItemDetail.CmdyId))),
                                  class: "h-[50px] tracking-[.1em] rounded-lg cursor-pointer text-white bg-gary-text-color sm:rounded-[10px]"
                                }, " 到貨通知我 "),
                                _withDirectives(_createElementVNode("span", _hoisted_84, "當商品重新上架可購買時，您將立即收到電子郵件通知", 512), [
                                  [_vShow, _ctx.mailShow === 1]
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_85, [
                                  true
                                    ? (_openBlock(), _createBlock(_component_Input, {
                                        key: 0,
                                        class: "grow mr-2 text-xs",
                                        width: '100%',
                                        height: '50px',
                                        placeholder: '請輸入Email',
                                        modelValue: _ctx.restockMail,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.restockMail) = $event))
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sentRestockNotification(_ctx.selectItemDetail.CmdyId))),
                                    class: "h-[50px] w-[50px] sm:w-[80px] tracking-[.1em] rounded-lg text-white bg-gary-text-color sm:rounded-[10px] hover:bg-primary-color active:bg-primary-color"
                                  }, " 發送 ")
                                ], 512), [
                                  [_vShow, _ctx.mailShow === 2]
                                ]),
                                _withDirectives(_createElementVNode("span", _hoisted_86, "謝謝您！當商品重新上架可購買時，您將立即收到電子郵件通知", 512), [
                                  [_vShow, _ctx.mailShow === 3]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectItemDetail.Status === 'ToBeActived' || _ctx.selectItemDetail.Status === 'SoldOut')
                            ? (_openBlock(), _createElementBlock("button", _hoisted_87, _toDisplayString(_ctx.selectItemDetail.Status === 'ToBeActived' ? '即將開賣' : '售完'), 1))
                            : _createCommentVNode("", true),
                          (
                  _ctx.selectItemDetail.Status === 'Active' &&
                  _ctx.selectItemDetail.IsEndProduct === 1
                )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addShoppingCart(_ctx.selectItemDetail))),
                                class: "grow h-[50px] tracking-[.1em] rounded-lg mr-3 sm:mr-7 text-white bg-gary-text-color sm:h-[50px] sm:rounded-[10px] hover:bg-primary-color active:bg-primary-color"
                              }, " 加入購物車 "))
                            : _createCommentVNode("", true),
                          (
                  _ctx.selectItemDetail.Status === 'Active' &&
                  _ctx.selectItemDetail.IsEndProduct === 0
                )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => {
                  _ctx.clickGoEditor();
                }),
                                class: "h-[50px] grow tracking-[.1em] rounded-lg mr-3 sm:mr-7 text-white bg-gary-text-color sm:h-[50px] sm:rounded-[10px] hover:bg-primary-color active:bg-primary-color"
                              }, " 開始訂製 "))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_88, [
                            (
                    _ctx.getSelectPrice.TotalOriAmt !== _ctx.getSelectPrice.TotalRealAmt
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, " NT. " + _toDisplayString(_ctx.getSelectPrice.TotalOriAmt), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_90, " NT. " + _toDisplayString(_ctx.getSelectPrice.TotalRealAmt), 1)
                          ])
                        ]),
                        _hoisted_91
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isGoProductDetailRef === true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", {
                            class: "h-[36px] w-[120px] cursor-pointer flex mb-4 sm:mb-0 justify-between text-xs sm:text-sm tracking-[.1em] py-[10px] sm:py-[13px] rounded-lg bg-gary-text-color sm:h-[50px] sm:w-[160px] sm:rounded-[10px] hover:bg-primary-color active:bg-primary-color",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goProductDetail(_ctx.selectItemDetail.CmdyId)))
                          }, [
                            _hoisted_94,
                            _createVNode(_component_Icon, {
                              class: "sm:hidden mr-[10px]",
                              iconName: "arrow_white",
                              width: "16px"
                            }),
                            _createVNode(_component_Icon, {
                              class: "hidden sm:block mr-[20px]",
                              iconName: "arrow_white",
                              width: "24px"
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "close hidden sm:block cursor-pointer",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeRecItem()))
                  }, [
                    _createVNode(_component_Icon, {
                      iconName: "close",
                      width: "14px"
                    })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, JSON.stringify(_ctx.selectItemDetail) !== '{}']
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_95,
    _createVNode(_component_AddPortFolioModal, {
      modelValue: _ctx.portfolioName,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.portfolioName) = $event)),
      ref: "addPortFolioModal"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_AddOnModal, {
      show: _ctx.showAddOnModal,
      cmdyType: _ctx.selectedType,
      AddOnCmdyItem: _ctx.selectAddOnCmdy,
      MainCmdyId: _ctx.productStore.state.selectedCmdy.CmdyId,
      setPackage: _ctx.setPackage,
      onOk: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showAddOnModal = false)),
      onCancel: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showAddOnModal = false)),
      "onUpdate:AddOnCmdyItem": _ctx.updateCmdyAddOn
    }, null, 8, ["show", "cmdyType", "AddOnCmdyItem", "MainCmdyId", "setPackage", "onUpdate:AddOnCmdyItem"])
  ], 64))
}